export const ANALYTIC_DETAIL_MODE = 'ANALYTIC_DETAIL';
export const ANALYTIC_LIST_MODE = 'ANALYTIC_LIST';
export const DEFAULT_VISIBLE_PARTS_SETTING = 127;

export const DEFAULT_VISIBLE_PARTS = [
  '床',
  '天井',
  '壁',
  'EQ',
  'STK',
  'Hanging',
  'Buffer',
];
